class BalanceSubscriptionPurchase extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector("[data-variants-json]").textContent);
    this.subscriptionProductJson = this.querySelector("[data-subscription-product-json]");
    this.subscriptionProduct = this.subscriptionProductJson
      ? JSON.parse(this.subscriptionProductJson.textContent)
      : null;
    this.hasSubscriptionProduct = this.dataset.hasSubscriptionProduct === "true";
    this.oneTimeVariantId = Number(this.dataset.oneTimeVariantId);
    this.subscriptionVariantId = Number(this.dataset.subscriptionVariantId) || null;
    this.selectedOneTimeVariantId = this.oneTimeVariantId;
    this.selectedOneTimeVariant = null;
    this.selectedCartQuantity = 1;
    this.variantInput = this.querySelector("[data-variant-id]");
    this.quantityInput = this.querySelector("[data-quantity]");
    this.installments = this.querySelector("[data-installments]");
    this.subscriptionDiscount = this.querySelector("[data-subscription-discount]");
    this.subscriptionCompare = this.querySelector("[data-subscription-compare]");
    this.subscriptionPrice = this.querySelector("[data-subscription-price]");
    this.oneTimePrice = this.querySelector("[data-one-time-price]");
    this.oneTimeCompare = this.querySelector("[data-one-time-compare]");
    this.oneTimeDiscount = this.querySelector("[data-one-time-discount]");
    this.oneTimePriceMeta = this.querySelector("[data-one-time-price-meta]");
    this.subscriptionPerDose = this.querySelector("[data-subscription-per-dose]");
    this.oneTimePerDose = this.querySelector("[data-one-time-per-dose]");
    this.subscriptionSavings = this.querySelector("[data-subscription-savings]");
    this.summaryPackages = this.querySelector("[data-summary-packages]");
    this.summaryDiscount = this.querySelector("[data-summary-discount]");
    this.dosesPerPack = Number(this.dataset.dosesPerPack) || 0;
    this.quantityMode = this.dataset.quantityMode || "weight";
    this.hideQuantity = this.dataset.hideQuantity === "true";
    this.progressiveMode = this.dataset.progressiveMode === "true";
    this.submitButton = this.querySelector("[data-submit]");
    this.form = this.querySelector("form");
    this.purchaseOptionIndex = this.parseOptionIndex(this.dataset.purchaseOptionIndex);
    const selectedWeightButton = this.querySelector("[data-quantity-option].is-selected");
    this.selectedQuantity = this.hideQuantity
      ? 1
      : selectedWeightButton
        ? Number(selectedWeightButton.dataset.quantityOption)
        : Number(this.quantityInput.value) || 1;
    this.selectedPurchaseOption = this.hasSubscriptionProduct && !this.progressiveMode
      ? "Assinatura Mensal"
      : "Compra única";
    this.syncQuantityInput();

    this.querySelectorAll("[data-quantity-option]").forEach((button) => {
      button.addEventListener("click", () => this.selectQuantity(button));
    });

    this.querySelectorAll("[data-purchase-option]").forEach((button) => {
      button.addEventListener("click", () => this.selectPurchaseOption(button));
    });

    if (this.form) {
      this.form.addEventListener("submit", () => this.updateVariant(), { capture: true });
    }

    if (this.progressiveMode) {
      document.addEventListener("balance-progressive-discount:change", (event) => {
        this.selectProgressiveQuantity(event.detail);
      });
      this.syncFromProgressiveOption();
    }

    this.updateVariant();
  }

  syncFromProgressiveOption() {
    const selectedOption = document.querySelector(
      "[data-balance-progressive-discount] .progressive-discount__option--selected",
    );

    if (!selectedOption) return;

    this.selectProgressiveQuantity({
      packageCount: Number(selectedOption.dataset.packageCount) || 1,
      cartQuantity: Number(selectedOption.dataset.cartQuantity) || Number(selectedOption.dataset.packageCount) || 1,
      variantId: Number(selectedOption.dataset.variantId) || this.oneTimeVariantId,
      price: Number(selectedOption.dataset.optionPrice) || 0,
      comparePrice: Number(selectedOption.dataset.optionComparePrice) || 0,
    });
  }

  selectProgressiveQuantity(detail = {}) {
    const packageCount = Number(detail.packageCount) || 1;
    const cartQuantity = Number(detail.cartQuantity) || packageCount;
    const variantId = Number(detail.variantId) || this.oneTimeVariantId;
    const price = Number(detail.price) || 0;
    const comparePrice = Number(detail.comparePrice) || price;

    this.selectedQuantity = packageCount;
    this.selectedCartQuantity = cartQuantity;
    this.selectedOneTimeVariantId = variantId;
    this.selectedOneTimeVariant = {
      id: variantId,
      price,
      compare_at_price: comparePrice,
      available: true,
      options: [],
    };
    this.syncQuantityInput();
    this.updateVariant();
  }

  selectQuantity(button) {
    if (this.hideQuantity) return;
    this.selectedQuantity = Number(button.dataset.quantityOption);
    this.syncQuantityInput();
    this.toggleButtons("[data-quantity-option]", button);
    this.updateVariant();
  }

  selectPurchaseOption(button) {
    const isSelected = button.classList.contains("is-selected");
    const isSubscriptionButton = this.normalize(button.dataset.purchaseOption) === "assinatura-mensal";

    if (this.progressiveMode && isSelected && isSubscriptionButton) {
      this.selectedPurchaseOption = "Compra unica";
      this.toggleButtons("[data-purchase-option]", null);
      this.syncQuantityInput();
      this.updateVariant();
      return;
    }

    this.selectedPurchaseOption = button.dataset.purchaseOption;
    this.toggleButtons("[data-purchase-option]", button);
    this.syncQuantityInput();
    this.updateVariant();
  }

  syncQuantityInput() {
    if (!this.quantityInput) return;

    const variant = this.getActiveVariant();
    this.quantityInput.value = variant ? this.getCartQuantity(variant) : this.isSubscriptionSelected() ? 1 : this.selectedQuantity;
  }

  variantUsesPackCount(variant) {
    return this.getPackCountFromVariant(variant) != null;
  }

  getCartQuantity(variant) {
    if (!variant) return 1;
    if (this.isSubscriptionSelected()) return 1;
    if (this.progressiveMode) return this.selectedCartQuantity;
    if (this.variantUsesPackCount(variant)) return 1;
    return this.selectedQuantity;
  }

  getVariantTotal(variant) {
    if (!variant) return 0;
    if (this.progressiveMode && !this.isSubscriptionTypeVariant(variant)) {
      return variant.price * this.selectedCartQuantity;
    }
    if (this.variantUsesPackCount(variant)) return variant.price;
    return variant.price * this.selectedQuantity;
  }

  getOneTimeTotal(variant) {
    return this.getVariantTotal(variant);
  }

  getActiveVariantTotal(variant = this.getActiveVariant()) {
    if (!variant) return 0;
    if (this.isSubscriptionSelected()) return variant.price;
    if (this.progressiveMode) return variant.price * this.selectedCartQuantity;
    if (this.variantUsesPackCount(variant)) return variant.price;
    return variant.price * this.selectedQuantity;
  }

  toggleButtons(selector, selectedButton) {
    this.querySelectorAll(selector).forEach((button) => {
      const selected = button === selectedButton;
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-pressed", selected);
    });
  }

  isSubscriptionSelected() {
    return this.normalize(this.selectedPurchaseOption) === "assinatura-mensal";
  }

  parseOptionIndex(value) {
    if (value == null || value === "") return null;
    const index = Number(value);
    return Number.isNaN(index) ? null : index;
  }

  getVariantOptionValues(variant) {
    if (!variant) return [];

    const values = [];
    if (variant.title) values.push(variant.title);
    if (Array.isArray(variant.options)) values.push(...variant.options);
    ["option1", "option2", "option3"].forEach((key) => {
      if (variant[key]) values.push(variant[key]);
    });

    return values;
  }

  isSubscriptionTypeVariant(variant) {
    return this.getVariantOptionValues(variant).some(
      (value) => this.normalize(value) === "assinatura-mensal",
    );
  }

  getPackCountFromVariant(variant) {
    if (!variant) return null;

    for (const source of this.getVariantOptionValues(variant)) {
      const value = String(source);
      const packMatch = value.match(/(\d+)\s*pacotes?/i);
      if (packMatch) return Number(packMatch[1]);
      const unitMatch = value.match(/(\d+)\s*unidades?/i);
      if (unitMatch) return Number(unitMatch[1]);
    }

    return null;
  }

  getSubscriptionVariant() {
    if (!this.subscriptionProduct?.variants?.length) return null;

    const variants = this.subscriptionProduct.variants;
    const byPackCount = variants.find(
      (variant) => this.getPackCountFromVariant(variant) === this.selectedQuantity,
    );
    if (byPackCount) return byPackCount;

    const byIndex = variants[this.selectedQuantity - 1];
    if (byIndex) return byIndex;

    const preferredVariant = variants.find((variant) => variant.id === this.subscriptionVariantId);
    if (preferredVariant) return preferredVariant;

    return variants.find((variant) => variant.available) || variants[0];
  }

  isOneTimeVariant(variant) {
    if (!variant) return false;
    if (this.isSubscriptionTypeVariant(variant)) return false;

    if (this.purchaseOptionIndex == null) return true;

    const purchaseOption = this.normalize(variant.options?.[this.purchaseOptionIndex]);
    return purchaseOption === "compra-unica";
  }

  getOneTimeVariants() {
    return this.variants.filter((variant) => this.isOneTimeVariant(variant));
  }

  sortVariantsByPackCount(variants) {
    return [...variants].sort((left, right) => {
      const leftPackCount = this.getPackCountFromVariant(left) ?? Number.MAX_SAFE_INTEGER;
      const rightPackCount = this.getPackCountFromVariant(right) ?? Number.MAX_SAFE_INTEGER;
      return leftPackCount - rightPackCount;
    });
  }

  getOneTimeVariant() {
    const oneTimeVariants = this.getOneTimeVariants();

    if (this.progressiveMode) {
      return (
        oneTimeVariants.find((variant) => variant.id === this.selectedOneTimeVariantId) ||
        this.selectedOneTimeVariant ||
        oneTimeVariants.find((variant) => variant.id === this.oneTimeVariantId) ||
        oneTimeVariants.find((variant) => this.getPackCountFromVariant(variant) == null) ||
        oneTimeVariants[0] ||
        this.variants.find((variant) => !this.isSubscriptionTypeVariant(variant)) ||
        this.variants[0]
      );
    }

    const byPackCount = (variants) =>
      variants.find((variant) => this.getPackCountFromVariant(variant) === this.selectedQuantity);

    const packMatch = byPackCount(oneTimeVariants);
    if (packMatch) return packMatch;

    const sortedByPack = this.sortVariantsByPackCount(oneTimeVariants);
    const byIndex = sortedByPack[this.selectedQuantity - 1];
    if (byIndex) return byIndex;

    const singleVariantWithoutPack = oneTimeVariants.find(
      (variant) => this.getPackCountFromVariant(variant) == null,
    );
    if (singleVariantWithoutPack) return singleVariantWithoutPack;

    return (
      oneTimeVariants.find((variant) => variant.id === this.oneTimeVariantId) ||
      oneTimeVariants[0] ||
      this.variants.find((variant) => !this.isSubscriptionTypeVariant(variant)) ||
      this.variants[0]
    );
  }

  getActiveVariant() {
    return this.isSubscriptionSelected() ? this.getSubscriptionVariant() : this.getOneTimeVariant();
  }

  updateVariant() {
    const variant = this.getActiveVariant();
    if (!variant) return;

    this.variantInput.value = variant.id;
    this.updatePrices();
    this.updateInstallments(variant);
    this.updateSubmitState(variant);
    this.syncStickyCart(variant);
  }

  updateSubmitState(variant = this.getActiveVariant()) {
    if (!this.submitButton || !variant) return;
    this.submitButton.toggleAttribute("disabled", !variant.available);
  }

  syncStickyCart(variant) {
    if (!variant) return;

    const stickyForm = document.querySelector(".sticky-cart__form form[data-type='add-to-cart-form']");
    if (!stickyForm) return;

    const stickyVariantInput = stickyForm.querySelector('input[name="id"]');
    if (stickyVariantInput) {
      stickyVariantInput.removeAttribute("disabled");
      stickyVariantInput.value = variant.id;
    }

    const stickyQuantityInput = stickyForm.querySelector('input[name="quantity"]');
    if (stickyQuantityInput) {
      stickyQuantityInput.value = this.getCartQuantity(variant);
    }
  }

  updateInstallments(variant = this.getActiveVariant()) {
    if (!variant || !this.installments) return;

    const total = this.getActiveVariantTotal(variant);
    const installment = total / 1;
    this.installments.innerHTML = `em até <strong>1x de ${this.formatMoney(installment)}</strong> sem juros`;
  }

  formatMoney(cents) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(cents / 100);
  }

  updatePerDose(totalCents, element) {
    if (!element || !this.dosesPerPack) return;

    const dosesTotal = this.dosesPerPack * this.selectedQuantity;
    const perDose = totalCents / dosesTotal;
    element.textContent = `${this.formatMoney(perDose)} por dose`;
  }

  findVariant(purchaseOption) {
    const normalizedPurchaseOption = this.normalize(purchaseOption);

    if (this.purchaseOptionIndex != null) {
      const indexedVariant = this.variants.find(
        (item) => this.normalize(item.options[this.purchaseOptionIndex]) === normalizedPurchaseOption,
      );
      if (indexedVariant) return indexedVariant;
    }

    return this.variants.find((item) =>
      item.options.some((option) => this.normalize(option) === normalizedPurchaseOption),
    );
  }

  updatePrices() {
    const oneTimeVariant = this.getOneTimeVariant();
    const subscriptionVariant = this.getSubscriptionVariant();

    if (oneTimeVariant) {
      const priceMultiplier = this.progressiveMode
        ? this.selectedCartQuantity
        : this.variantUsesPackCount(oneTimeVariant)
          ? 1
          : this.selectedQuantity;
      const oneTimeCompareAtPrice = oneTimeVariant.compare_at_price || oneTimeVariant.price;
      const oneTimeOriginalPrice = Math.max(oneTimeVariant.price, oneTimeCompareAtPrice) * priceMultiplier;
      const oneTimeSalePrice = Math.min(oneTimeVariant.price, oneTimeCompareAtPrice) * priceMultiplier;
      const oneTimeDiscountPercent =
        oneTimeOriginalPrice > oneTimeSalePrice
          ? Math.round(((oneTimeOriginalPrice - oneTimeSalePrice) * 100) / oneTimeOriginalPrice)
          : 0;

      if (this.oneTimePrice) this.oneTimePrice.textContent = this.formatMoney(oneTimeSalePrice);
      if (this.oneTimeCompare) this.oneTimeCompare.textContent = this.formatMoney(oneTimeOriginalPrice);
      if (this.oneTimeDiscount) this.oneTimeDiscount.textContent = `Economize ${oneTimeDiscountPercent}%`;
      if (this.oneTimePriceMeta) {
        this.oneTimePriceMeta.toggleAttribute("hidden", oneTimeOriginalPrice <= oneTimeSalePrice);
      }
      this.updatePerDose(oneTimeSalePrice, this.oneTimePerDose);
    }

    if (!subscriptionVariant) return;

    const subscriptionCompareAtPrice = subscriptionVariant.compare_at_price || subscriptionVariant.price;
    const subscriptionOriginalPrice = Math.max(subscriptionVariant.price, subscriptionCompareAtPrice);
    const subscriptionSalePrice = Math.min(subscriptionVariant.price, subscriptionCompareAtPrice);
    const subscriptionTotal = subscriptionSalePrice;
    const subscriptionCompareTotal = subscriptionOriginalPrice;
    const discountPercent =
      subscriptionOriginalPrice > subscriptionSalePrice
        ? Math.round(((subscriptionOriginalPrice - subscriptionSalePrice) * 100) / subscriptionOriginalPrice)
        : 0;

    if (this.subscriptionCompare) {
      this.subscriptionCompare.textContent = this.formatMoney(subscriptionCompareTotal);
    }
    if (this.subscriptionPrice) {
      this.subscriptionPrice.textContent = this.formatMoney(subscriptionTotal);
    }
    if (this.subscriptionDiscount) {
      this.subscriptionDiscount.textContent = this.progressiveMode
        ? `-${discountPercent}%`
        : `Economize ${discountPercent}%`;
    }
    this.updatePerDose(subscriptionTotal, this.subscriptionPerDose);
    this.updateSavings(subscriptionCompareTotal - subscriptionTotal);
    this.updateProgressiveSummary(discountPercent);
  }

  updateSavings(savings) {
    if (!this.subscriptionSavings) return;
    this.subscriptionSavings.textContent = `economia de ${this.formatMoney(Math.max(savings, 0))}`;
  }

  updateProgressiveSummary(discountPercent) {
    if (!this.progressiveMode) return;

    const packages = this.selectedQuantity;
    const units = (this.dosesPerPack || 30) * packages;
    const packageLabel = packages === 1 ? "pacote" : "pacotes";

    if (this.summaryPackages) {
      this.summaryPackages.textContent = `${packages} ${packageLabel} (${units} unidades)`;
    }

    if (this.summaryDiscount) {
      this.summaryDiscount.textContent = `${discountPercent}% de desconto`;
    }
  }

  normalize(value = "") {
    return String(value)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/\s+/g, "-");
  }
}

if (!customElements.get("balance-subscription-purchase")) {
  customElements.define("balance-subscription-purchase", BalanceSubscriptionPurchase);
}
